import { render, staticRenderFns } from "./page-detail-contract.vue?vue&type=template&id=29bb06eb&scoped=true&"
import script from "./page-detail-contract.vue?vue&type=script&lang=js&"
export * from "./page-detail-contract.vue?vue&type=script&lang=js&"
import style0 from "./page-detail-contract.vue?vue&type=style&index=0&id=29bb06eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb06eb",
  null
  
)

export default component.exports